import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const moveStopsState = (state: RootState) => state.scene.route.moveStops;

export const getMoveStopsSourceRoute = createSelector(
  moveStopsState,
  ({ sourceRoute }) => sourceRoute
);
export const isMoveStopsVisible = createSelector(
  moveStopsState,
  ({ sourceRoute }) => !!sourceRoute
);
export const getMoveStopsRoutes = createSelector(moveStopsState, ({ routes }) => routes);
export const isMoveStopsRoutesLoading = createSelector(
  moveStopsState,
  ({ routesLoading }) => routesLoading
);
export const isMoveStopsTransferring = createSelector(
  moveStopsState,
  ({ transferring }) => transferring
);
